import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-legends-container',
    templateUrl: './legends-container.component.html',
    styleUrls: ['./legends-container.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LegendsContainerComponent implements OnInit {

	@Input() legends: any[] = [];
	@Input() scroll: boolean = false;
	@Input() standalone: boolean = true;
	@Input() gridLegends: boolean = false;
	@Input() showValueLegend: boolean = false;
	@Input() orientation: string = 'horizontal'
	@Input() dataType: string = 'number';

	constructor() { }

	ngOnInit(): void {

	}

}
